import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Users, GraduationCap } from 'lucide-react';
import AdminAllUsersPage from './AdminAllUsersPage';
import AdminLearnersPage from './AdminLearnersPage';

export default function AdminPeoplePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 'users';

  const setTab = (value) => {
    setSearchParams({ tab: value });
  };

  return (
    <div className="space-y-6" data-testid="admin-people-page">
      <div>
        <h1 className="font-heading text-2xl font-bold flex items-center gap-2">
          <Users className="w-6 h-6" /> People
        </h1>
        <p className="text-muted-foreground">Manage users and learners</p>
      </div>

      <Tabs value={tab} onValueChange={setTab}>
        <TabsList>
          <TabsTrigger value="users" className="flex items-center gap-2" data-testid="tab-users">
            <Users className="h-4 w-4" />
            Users
          </TabsTrigger>
          <TabsTrigger value="learners" className="flex items-center gap-2" data-testid="tab-learners">
            <GraduationCap className="h-4 w-4" />
            Learners
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <AdminAllUsersPage embedded />
        </TabsContent>
        <TabsContent value="learners">
          <AdminLearnersPage embedded />
        </TabsContent>
      </Tabs>
    </div>
  );
}
